export default __webpack_public_path__ + "static/media/vasily-koloda-8CqDvPuo_kI-unsplash@2x.0d375051.png";